module.exports = __webpack_public_path__ + "static/media/scoreit_large_01_ligth.80137e6f.png";